// Home.js
import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <div>
      <h1>Welcome to the Home Page</h1>
      <nav>
        <ul>
          <li>
            <Link to="/devotionals">Devotionals</Link>
          </li>
          <li>
            <Link to="/organizations">Organizations</Link>
          </li>
          <li>
            <Link to="/applications">Applications</Link>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Home;
